import React from 'react'
import SiteGrid from "../ui/SiteGrid"
import AppButton from "../ui/AppButton"
import SquareGrid from "../ui/SquareGrid"

export default function HeroSection() {

  return (
    <div className="hero-section home-section">
      <div className="hero-bg" />
      <SiteGrid>
        <div className="hero-content">
          <h1>Empowering Patients<br />to Live Their Best<br /><span>Lives</span></h1>
          <p>
            With a focus on patient education, empowerment, and personalized
            care, we are dedicated to helping you achieve your goals and
            live your best life.
          </p>
          <AppButton
            label="Learn More"
            url="/about/our-story"
            buttonType="withShadow"
          />
        </div>
      </SiteGrid>
      <div className="circle-1 circle"/>
      <div className="circle-2 circle"/>
      <div className="circle-3 circle"/>
      <SquareGrid />
    </div>
  )
}
